import { useTranslations } from "use-intl";
import type { FlightsSortValue } from "@/app/lib/types/types";
import { DrawerTopBar } from "../Drawer";
import FlightsSort from "./flight-filters/FlightsSort";
import { SwipeableDrawer } from "../SwipeableDrawer";

type Props = {
  open: boolean;
  value: FlightsSortValue;
  onSubmit: (newValue: FlightsSortValue) => void;
  onClose: () => void;
};

export const FlightsSortDrawer = ({
  open,
  value,
  onSubmit,
  onClose,
}: Props) => {
  const t = useTranslations();

  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      <DrawerTopBar onCloseClick={onClose} title={t("flights.sort")} />
      <FlightsSort value={value} onChange={onSubmit} />
    </SwipeableDrawer>
  );
};
